import { useEffect, useRef } from 'react';

import { BaseFormFieldProps } from '../FormField/FormField';
import { useFormContext } from 'react-hook-form';
import { hasValue } from '@r-and-a-shared-ui/utils';

const HiddenFieldWithValue = (props: BaseFormFieldProps) => {
  const { name, label } = props;

  const { setValue } = useFormContext();

  useEffect(() => {
    if (hasValue(label)) {
      setValue(name, label);
    }
  }, [name, setValue]);

  return null;
};

export default HiddenFieldWithValue;
